import {ActivatedRouteSnapshot, ResolveFn, Router, RouterStateSnapshot} from '@angular/router';
import {ApiResponse} from 'se-resource-types/dist/lib/common';
import {inject} from '@angular/core';
import {Store} from '@ngrx/store';
import {OrderHistoryActions} from '../state/order-history.actions';
import {filter, Observable, of, take} from 'rxjs';
import {DEFAULT_ORDERS_PAGINATION_PARAMS, selectOrdersPage} from '../state/order-history.reducer';
import {PaginationParameters} from '../../models/pagination-parameters';
import {Sale} from 'se-resource-types/dist/lib/Clare';

export const ordersResolver: ResolveFn<Observable<ApiResponse<Sale[]> | undefined>> = (
  route: ActivatedRouteSnapshot,
  __state: RouterStateSnapshot
) => {
  const store = inject(Store);
  const router = inject(Router);
  const params = route.queryParams as PaginationParameters;
  if (!params.currentPage || !params.limit) {
    router.navigate(['/orders'], {queryParams: {...DEFAULT_ORDERS_PAGINATION_PARAMS}});
    return of(undefined);
  }

  store.dispatch(OrderHistoryActions.loadOrders({params}));

  return store.select(selectOrdersPage).pipe(
    filter(page => page !== undefined),
    take(1)
  );
};
